<template>
  <el-row class="xh-esg-page">
    <el-col :span="24">
      <div class="xh-esg-right-content infoArea">
        <el-row class="xh-esg-page-container" :gutter="20">
          <el-col :span="12" v-for="(item, index) in pageData" :key="index">
            <div class="xh-esg-page-item">
              <div class="xh-esg-page-title-content">
                <i></i>
                <div class="xh-esg-page-title">
                  {{ item.label }}
                </div>
              </div>
              <div
                class="xh-esg-page-title-sub"
                v-if="$filters.empty(item.info)"
              >
                {{ item.info | empty }}
              </div>
              <div class="xh-esg-page-chart">
                <component
                  :is="getComponent(index)"
                  :url="getLinkUrl(index)"
                  class="xh-esg-page-chart-item"
                  methods="post"
                  legend
                ></component>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions } from "vuex";
import e4ring from "@/components/charts/e4ring";
import e4bar2vertical4standard from "@/components/charts/e4bar2vertical4standard";

export default {
  data() {
    return {
      pageData: [],
    };
  },
  components: {
    e4ring,
    e4bar2vertical4standard,
  },
  mounted() {
    this.getPageList().then((data) => {
      this.pageData = data;
    });
  },
  methods: {
    ...mapActions("investInfo/index", {
      getPageList: "GET_PAGE_LIST",
    }),
    getCurrentInfo(index){
      let infoMapping =[{
        url: "/esg/assets/esg_fund_product_publish",
        component: "e4bar2vertical4standard"
      },{
        url: "/esg/assets/XHS_ESG_SCALE_SCOPE",
        component: "e4ring"
      },{
        url: "/esg/assets/XHS_ESG_PUBLIC_STRATEGY_TYPE",
        component: "e4ring"
      },{
        url: "/esg/assets/XHS_ESG_PUBLIC_FUND_INVESTMENT",
        component: "e4ring"
      }]
      return infoMapping[index] || infoMapping[0]
    },
    getComponent(index){
      return this.getCurrentInfo(index).component;
    },
    getLinkUrl(index){
      return this.getCurrentInfo(index).url;
    }
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-page {
  .xh-esg-right-content {
    background-color: var(--comp_06);
    padding: 0 20px;
    min-height: 520px;

    .xh-esg-page-item {
      padding: 20px 0;
      min-height: 230px;
      .xh-esg-page-title {
        font-size: 12px;
        font-weight: 500;
        color: var(--font_01);
        line-height: 20px;
        display: inline-block;
        vertical-align: middle;
      }
      .xh-esg-page-title-sub {
        font-size: 12px;
        font-weight: 400;
        color: var(--font_01);
        line-height: 17px;
        background: var(--comp_07) ;
        padding: 15px;
      }
      .xh-esg-page-title-content {
        margin-bottom: 10px;
        i {
          height: 10px;
          width: 10px;
          background-color: #7ad5f4;
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
          border-radius: 10px;
        }
      }
      .xh-esg-page-chart-item {
        height: 250px;
        width: 350px;
      }
    }
  }
}
</style>